<template lang='pug'>
//- Profile-Page
div(:class='$style[`cc-profile-container`]')
  div(v-if='!isPreloading' :class='$style[`cc-profile-banner`]')
    div(:class='$style[`cc-banner-status`]')
      div(:class='$style[`cc-banner-status-wrap`]')
        div(v-if='profileData.user_type === `doctor`' :class='$style[`cc-banner-avatar`]')
          div(:class='$style[`cc-avatar-public`]') {{ `公開帳號` }}
          figure(v-if='profileData.thumbSrc === ``' :class='$style[`cc-avatar-photo`]')
            //- Doctor-Male-Avatar
            img(
              v-if='profileData.gender === `0`'
              :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
              width='100%'
              height='100%')
            //- Doctor-Female-Avatar
            img(
              v-else
              :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
              width='100%'
              height='100%')

          figure(v-else :class='$style[`cc-avatar-photo`]')
            img(
              :src='avatarSrcLink(profileData.thumbSrc)'
              width='100%'
              height='100%')


        div(v-if='profileData.user_type === `normal`' :class='$style[`cc-banner-avatar`]')
          div(:class='$style[`cc-avatar-public`]') {{ profileData.public === `yes` ? `公開帳號` : `匿名帳號` }}

          figure(v-if='profileData.thumbSrc !== `` && profileData.public' :class='$style[`cc-avatar-photo`]')
            img(
              :src='avatarSrcLink(profileData.thumbSrc)'
              width='100%'
              height='100%')

          figure(v-else :class='$style[`cc-avatar-photo`]')
            img(
              v-if='profileData.gender === `0`'
              :src='`${STATIC_URL}images/common/user/normal_male.webp`'
              width='100%'
              height='100%')
            img(
              v-else
              :src='`${STATIC_URL}images/common/user/normal_female.webp`'
              width='100%'
              height='100%')



        //- 個人頭像大標題
        div(:class='$style[`cc-banner-main-member`]')
          div.font-bold(v-if='profileData.user_type ===`doctor`' :class='$style[`cc-banner-main-name`]')
            span.font-doctor-theme(v-if='profileData.user_type ===`doctor`') {{ `${profileData.firstName}${profileData.lastName}` }}
            //- span.no-wrap!= '醫師'
            span.no-wrap {{ profileData.character }}

            //- div(:class='$style[`cc-avatar-upload-btn`]')
            //-   button(
            //-     title='編輯大頭照' tabindex='0' aria-label='編輯頭像'
            //-     @click='handleClickEditThumbSrc'
            //-   ) 編輯頭像

          div.font-bold(v-if='profileData.user_type ===`normal`' :class='$style[`cc-banner-main-name`]')
            span.font-normal-theme(v-if='profileData.public ===`yes`') {{ `${profileData.firstName}${profileData.lastName}` }}
            span.font-normal-theme(v-else) {{ profileData.gender === `0` ? `${profileData.firstName}先生` : `${profileData.firstName}小姐` }}
            span.no-wrap!= '會員'

          div(:class='$style[`cc-banner-main-index`]')
            span {{ `會員編號 ${this.$route.params.id}` }}

          div(:class='$style[`cc-banner-sub-panel`]')

            div(
              v-if='profileData.verified === `yes`'
              :class='[$style[`cc-banner-sub-verify`], $style[`cc-is-verify`]]')
              div(:class='$style[`cc-banner-sub-verify-icon`]')
                IconConfirm(:size='16' :color='`#fff`')
              span!= '已認證'
            div(
              v-else
              :class='$style[`cc-banner-sub-verify`]')
              div(:class='$style[`cc-banner-sub-verify-icon`]')
                IconConfirm(:size='16' :color='`#fff`')
              span!= '未認證'

            //- 加入追蹤按鈕
            div.bg-doctor-theme(
              v-if='profileData.user_type ===`doctor` && loginProfile.user_type === `normal` && `${loginDjangoId}` !== `${this.$route.params.id}`'
              :class='[$style[`cc-banner-sub-follow`], $style[ isFollowed ? `cc-isFollowed` : ``]]'
              @click='handleAddFollowDoctor') {{ isFollowed ? `已追蹤` : `加入追蹤` }}

            router-link(
              v-else-if='`${loginDjangoId}` === `${this.$route.params.id}`'
              role='button'
              tabindex='0'
              aria-label='編輯個人檔案'
              :class='[$style[`cc-banner-sub-detail`], profileData.user_type ===`doctor` ? `bg-doctor-theme` : `bg-normal-theme`]'
              :to='{ name: `setting` }'
            )!= '編輯個人檔案'


    div(:class='$style[`cc-banner-profile`]')
      //- 醫生選單區
      div(v-if='profileData.user_type ===`doctor`' :class='[$style[`cc-profile-menu`], $style[stateFlowBarFixed ? `flowBar-fixed` : ``]]')
        div(:class='$style[`cc-profile-menu-wrap`]')
          router-link(
            tag='nav'
            exact=true
            role='button'
            tabindex='0'
            aria-label='查看個人檔案'
            :class='$style[`cc-menu-nav`]'
            :active-class='$style[`js-selected`]'
            :to='{ name: `profile`, params: { type: this.$route.params.type, id: `${this.$route.params.id}` } }')
            IconData(:size='22' :color='`#b1b1b1`')
            span!= '會員'
              span.no-wrap!= '檔案'


          //- router-link(
          //-   tag='nav'
          //-   exact=true
          //-   role='button'
          //-   tabindex='0'
          //-   aria-label='查看收藏區'
          //-   :class='$style[`cc-menu-nav`]'
          //-   :active-class='$style[`js-selected`]'
          //-   :to='{ name: `profile-bookmark`, params: { type: this.$route.params.type, id: `${this.$route.params.id}` } }')
          //-   IconBookmark(:size='22' :color='`#b1b1b1`')
          //-   span!='收藏區'

          //- router-link(
          //-   tag='nav'
          //-   exact=true
          //-   role='button'
          //-   tabindex='0'
          //-   aria-label='查看討論板'
          //-   :class='$style[`cc-menu-nav`]'
          //-   :active-class='$style[`js-selected`]'
          //-   :to='{ name: `profile-record`, params: { type: this.$route.params.type, id: `${this.$route.params.id}` } }')
          //-   IconDialog(:size='22' :color='`#b1b1b1`')
          //-   span!= '討論板'

          router-link(
            tag='nav'
            exact=true
            role='button'
            tabindex='0'
            aria-label='查看追蹤者'
            :class='$style[`cc-menu-nav`]'
            :active-class='$style[`js-selected`]'
            :to='{ name: `profile-follower`, params: { type: this.$route.params.type, id: `${this.$route.params.id}` } }')
            IconFollower(:size='22' :color='`#b1b1b1`')
            span!='追蹤者'

          //- router-link(
          //-   tag='nav'
          //-   exact=true
          //-   :class='$style[`cc-menu-nav`]'
          //-   :active-class='$style[`js-selected`]'
          //-   :to='{ name: `profile-share`, params: { type: this.$route.params.type, id: `${this.$route.params.id}` } }')
          //-   IconQrcode(:size='22' :color='`#b1b1b1`')
          //-   span!= '專屬'
          //-     span.no-wrap!= '連結'


      //- 一般會員選單區
      div(v-else-if='profileData.user_type ===`normal`' :class='[$style[`cc-profile-menu`], $style[stateFlowBarFixed ? `flowBar-fixed` : ``]]')
        div(:class='$style[`cc-profile-menu-wrap`]')
          router-link(
            tag='nav'
            exact=true
            role='button'
            tabindex='0'
            aria-label='查看個人檔案'
            :class='$style[`cc-menu-nav`]'
            :active-class='$style[`js-selected`]'
            :to='{ name: `profile`, params: { type: this.$route.params.type, id: `${this.$route.params.id}` } }')
            IconData(:size='22' :color='`#b1b1b1`')
            span!= '會員'
              span.no-wrap!= '檔案'


          //- router-link(
          //-   tag='nav'
          //-   exact=true
          //-   role='button'
          //-   tabindex='0'
          //-   aria-label='查看故事卡'
          //-   :class='$style[`cc-menu-nav`]'
          //-   :active-class='$style[`js-selected`]'
          //-   :to='{ name: `profile-resume`, params: { type: this.$route.params.type, id: `${this.$route.params.id}` } }')
          //-   IconResumeCard(:size='22' :color='`#b1b1b1`')
          //-   span!= '故事卡'


          //- router-link(
          //-   tag='nav'
          //-   exact=true
          //-   role='button'
          //-   tabindex='0'
          //-   aria-label='查看討論板'
          //-   :class='$style[`cc-menu-nav`]'
          //-   :active-class='$style[`js-selected`]'
          //-   :to='{ name: `profile-record`, params: { type: this.$route.params.type, id: `${this.$route.params.id}` } }')
          //-   IconDialog(:size='22' :color='`#b1b1b1`')
          //-   span!= '問答'
          //-     span.no-wrap!= '紀錄'

          //- router-link(
          //-   tag='nav'
          //-   exact=true
          //-   role='button'
          //-   tabindex='0'
          //-   aria-label='查看收藏區'
          //-   :class='$style[`cc-menu-nav`]'
          //-   :active-class='$style[`js-selected`]'
          //-   :to='{ name: `profile-bookmark`, params: { type: this.$route.params.type, id: `${this.$route.params.id}` } }')
          //-   IconBookmark(:size='22' :color='`#b1b1b1`')
          //-   span!='收藏區'

          router-link(
            tag='nav'
            exact=true
            role='button'
            tabindex='0'
            aria-label='查看已追蹤'
            :class='$style[`cc-menu-nav`]'
            :active-class='$style[`js-selected`]'
            :to='{ name: `profile-following`, params: { type: this.$route.params.type, id: `${this.$route.params.id}` } }')
            IconFollowDoctor(:size='22' :color='`#b1b1b1`')
            span!='已追蹤'


      //- Router內容切換區
      div(:class='$style[`cc-profile-view`]')
        router-view
        //- router-view(name='detail')


  //- Preloader Container
  div(v-else :class='$style[`cc-preloader-content`]')
    div(:class='$style[`cc-preloader-banner`]')
      div(:class='$style[`cc-preloader-status`]')
        div.skeleton-preload(:class='$style[`cc-preloader-avatar`]')
        div(:class='$style[`cc-preloader-title`]')
          div.skeleton-preload(:class='$style[`cc-preloader-name`]')
          div.skeleton-preload(:class='$style[`cc-preloader-sub-title`]')

      div(:class='$style[`cc-preloader-main`]')
        div.skeleton-preload(:class='$style[`cc-preloader-menu`]')
        div.skeleton-preload(:class='$style[`cc-preloader-main-content`]')



</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { debounce } from 'debounce';
import {
  // getCurrentDate,
  deleteExistNotify,
  // postCreateNewNotify,

  getNormalData,
  getDoctorData,
  postAddFollow,
  deleteFollow,
} from '../../../js/restapi';

import IconConfirm from '../../icon/Confirm';
import IconUser from '../../icon/User';
import IconData from '../../icon/Data';
import IconGuild from '../../icon/Guild';
// import IconQrcode from '../../icon/Qrcode';
import IconDialog from '../../icon/Dialog';
import IconResumeCard from '../../icon/ResumeCard';
import IconBookmark from '../../icon/Bookmark';
import IconFollower from '../../icon/Follower';
import IconFollowDoctor from '../../icon/FollowDoctor';

export default {
  components: {
    IconConfirm,
    IconUser,
    IconData,
    // IconQrcode,
    IconDialog,
    IconGuild,
    IconBookmark,
    IconResumeCard,
    IconFollower,
    IconFollowDoctor,
  },

  data() {
    return {
      scrollTop: 0,
      flowBarFixedPosY: 0,
      flowBarOffsetTop: {
        desktop: 210,
        tablet: 186,
        mobile: 288,
      },

      profileData: {},
      isPreloading: true,
      isFollowed: false,
    };
  },

  created() {
    this.handleRouterTypeOnLoad(this.$route.params.type, this.$route.params.id);
    // console.log('Profile', this.$route.params.type, this.$route.params.id);
  },

  mounted() {
    // Do reset Vuex Before Dom rerender;
    window.addEventListener('scroll', this.handleFlowBarScrollFixed);
    console.log('route.path', this.$route);
    this.$nextTick(() => {
      this.clientWidthResize();
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.clientWidthResize);
    window.removeEventListener('scroll', this.handleFlowBarScrollFixed);
  },

  methods: {
    ...mapMutations({
      setFlowBarFixed: 'global/FLOW_BAR_FIXED',
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changeUpdateKey: 'global/FORCE_UPDATE_KEY',
    }),

    // createNewNotifyEvent(category, eventType) {
    //   if (`${this.loginDjangoId}` === `${this.$route.params.id}`) {
    //     console.log('偵測到Remind是同個人!!');
    //     return;
    //   }
    //   getCurrentDate('')
    //     .then((res) => {
    //       const POST_DATA = {
    //         auth_id: `${this.loginDjangoId}`,
    //         category,
    //         category_id: `${this.$route.params.id}`,
    //         remind_user_id: `${this.$route.params.id}`,
    //         remind: 'yes',
    //         date: `${res.data}`,
    //         behavior: eventType,
    //       };

    //       postCreateNewNotify('', POST_DATA)
    //         .then((res) => {
    //           console.log('建立通知成功!!');
    //         })
    //         .catch((err) => {
    //           console.log('建立通知失敗!!');
    //         });
    //     })
    //     .catch((err) => {});
    // },

    deleteNotifyEvent(eventType) {
      if (`${this.loginDjangoId}` === `${this.$route.params.id}`) {
        console.log('偵測到Remind是同個人!!');
        return;
      }

      const DELETE_DATA = {
        category_id: `${this.$route.params.id}`,
        remind_user_id: `${this.$route.params.id}`,
        auth_id: `${this.loginDjangoId}`,
        behavior: eventType,
      };

      deleteExistNotify('', {
        headers: {
          'content-Type': 'application/json',
        },
        data: JSON.stringify(DELETE_DATA),
      })
        .then((res) => {
          console.log('建立通知成功!!');
        })
        .catch((err) => {
          console.log('建立通知失敗!!');
        });
    },

    checkIfFollowMatched(recieveData) {
      // eslint-disable-next-line no-return-assign
      return recieveData.includes(this.loginDjangoId) ? this.isFollowed = true : this.isFollowed = false;
    },

    clientWidthResize() {
      this.clientWidth = document.documentElement.clientWidth;

      // INIT Rwd Type
      if (this.clientWidth > 1280) {
        this.flowBarFixedPosY = this.flowBarOffsetTop.desktop;
        // this.flowBarOffsetTop = this.$refs.indexFlowBar.getBoundingClientRect().top - this.$refs.indexFlowBar.clientHeight - 13;
      } else if (this.clientWidth <= 1280 && this.clientWidth > 730) {
        this.flowBarFixedPosY = this.flowBarOffsetTop.tablet;
      } else {
        this.flowBarFixedPosY = this.flowBarOffsetTop.mobile;
      }
    },

    handleAddFollowDoctor() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
      } else {
        this.isFollowed = !this.isFollowed;

        this.followDebounceEvent({
          isFollowed: this.isFollowed,
        });

        if (this.isFollowed) {
          this.changePopBoxStatus({
            active: true,
            include: 'followConfirm',
          });
          setTimeout(() => {
            this.changePopBoxStatus({
              active: false,
              include: '',
            });
          }, this.POP_DURATION);
        }
      }
    },

    // eslint-disable-next-line func-names
    followDebounceEvent: debounce(function (e) {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const UPDATE_DATA = {
        type: '',
        user_id: `${this.loginDjangoId}`,
        doct_id: `${this.$route.params.id}`,
        size: '1',
        page: '1',
      };

      if (e.isFollowed) {
        postAddFollow('', UPDATE_DATA, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        })
          .then((/* response */) => {
            console.log('%c 加入追蹤 成功 :', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;');
            // this.createNewNotifyEvent('follow', 'new-follower');
            // this.handleUserAddHp(this.loginDjangoId, '+50');
          })
          .catch((error) => {
            console.error('加入追蹤 失敗！', error.response);
          });
      } else {
        deleteFollow('', {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
          data: JSON.stringify(UPDATE_DATA),
        })
          .then((/* response */) => {
            console.log('%c 刪除追蹤 成功', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;');
            this.deleteNotifyEvent('new-follower');
            // this.handleUserAddHp(this.loginDjangoId, '-50');
          })

          .catch((error) => {
            console.error('刪除追蹤 失敗！', error.response);
            if (error.response.status === 401) {
              this.changePopBoxStatus({
                active: true,
                include: 'relogin',
              });
            }
          });
      }
    }, 300),

    handleRouterTypeOnLoad(userType, id) {
      switch (userType) {
        case 'doctor':
          getDoctorData(`/?pk=${id}`)
            .then((response) => {
              this.profileData = response.data;
              this.isPreloading = false;

              if (this.loginStatus && this.loginProfile.user_type === 'normal') {
                this.checkIfFollowMatched(response.data.follower);
              }
            })
            .catch((/* error */) => {
              console.error('getDoctorData 失敗！');
              this.$router.replace({
                name: 'error404',
              }).catch(() => true);
            });

          break;

        case 'normal':
          getNormalData(`/?pk=${id}`)
            .then((response) => {
              this.profileData = response.data;
              this.isPreloading = false;
            })
            .catch((/* error */) => {
              console.error('getNormalData 失敗！');
              this.$router.replace({
                name: 'error404',
              }).catch(() => true);
            });

          break;
        default:
          break;
      }
    },

    handleFlowBarScrollFixed() {
      this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      // console.log('ScrollTop: ', this.scrollTop);
      if (this.scrollTop > this.flowBarFixedPosY) {
        this.setFlowBarFixed(true);
      } else {
        this.setFlowBarFixed(false);
      }
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      stateFlowBarFixed: 'global/exportFlowBarFixed',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  // watch: {
  //   $route(to, from) {
  //     if (to.name === 'profile-detail' || to.name === 'profile-bookmark' || to.name === 'profile-follower' || to.name === 'profile-following' || to.name === 'profile-resume' || to.name === 'profile-record') {
  //       this.changeUpdateKey();
  //       alert('UPDATE');
  //     }
  //   },
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/member/profile.scss';
</style>
